export var EGeoCoordinatesEditorSize;
(function (EGeoCoordinatesEditorSize) {
    EGeoCoordinatesEditorSize["SMALL"] = "SMALL";
    EGeoCoordinatesEditorSize["MEDIUM"] = "MEDIUM";
})(EGeoCoordinatesEditorSize || (EGeoCoordinatesEditorSize = {}));
